import "./filters.css";
import { useEffect, useState, useRef } from "react";
import Input from "../formBasic/Input";
import CalendarFilter from "../../../assets/svgs/calendaFilter.svg";
import SearchFilterIcon from "../../../assets/svgs/searchFilter.svg";
import Filter from "../../../assets/img/filter.png";
import LixoIcon from "../../../assets/svgs/lixo.svg";
import IconAlert from "../../../assets/svgs/icon-alert.svg";
import { CalendarInput } from "../../calendarInput/Calendarinput";
import ContainerError from "../../error/containerError";
import { getDashboard } from "../../../redux/actions/fluxoNSimilar";
import { useDispatch, useSelector } from "react-redux";
import { ButtonGeneric } from "../../ButtonGeneric/buttonGeneric";
import { handleDateTypingUtil } from "../../../utils/formatCalendarDate";
import { useRoles } from "../../../hooks/roles";
import { RootState } from "../../../redux/store";
import { BaseFilterPage } from "../../../types/filterPage";
import { validateDates } from "../../../utils/dateUtils";
import { useDateRangePersisted } from "../../../hooks/useDateRangePersisted";

export interface FilterPageDash extends BaseFilterPage {}

const FiltersDasboard = ({
  setStartDate,
  startDate,
  endDate,
  setEndDate,
  handleFilter,
  emitentePartNumber,
  setEmitentePartDesc,
}: FilterPageDash) => {
  const dispatch = useDispatch();
  const { isTax } = useRoles();
  const [calendarKey, setCalendarKey] = useState(0);

  const {
    dateRange,
    setDateRange,
    startDateLocal,
    setStartDateLocal,
    endDateLocal,
    setEndDateLocal,
  } = useDateRangePersisted(startDate, endDate);

  const [, setCenterFilterError] = useState("");
  const [emitenteDescError, setEmitenteDescErrorr] = useState("");
  const [, setErrorApi] = useState(false);
  const [dateError, setDateError] = useState("");
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [, setErrorApply] = useState(false);
  const MAX_LENGTH = 49;

  const emitenteInputRef = useRef<HTMLInputElement>(null);

  const clearFilters = async () => {
    setCenterFilterError("");
    setDateRange(["", ""]);
    setStartDate("");
    setEndDate("");
    setStartDateLocal("");
    setEndDateLocal("");
    setCalendarKey((prevKey) => prevKey + 1);
    setDateError("");
    setErrorApi(false);
    setEmitentePartDesc("");

    await dispatch(
      getDashboard({
        emitter: "",
        startDate: "",
        endDate: "",
      })
    );
  };

  const { sessionDashboard } = useSelector(
    (state: RootState) => state.sessionClassifications
  );

  const isFilterButtonDisabled =
    (!startDate && !endDate && (!isTax || !emitentePartNumber)) ||
    (startDate && endDate && endDate < startDate) ||
    dateError;

  const handleDateTyping = (from: string, to: string) => {
    handleDateTypingUtil(from, to, setStartDate, setEndDate, setDateError);
  };

  useEffect(() => {
    setDateRange([startDateLocal, endDateLocal]);
  }, [startDateLocal, endDateLocal]);

  const handleEmitenteChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    if (value.length >= MAX_LENGTH) {
      setEmitenteDescErrorr("Limite de 50 caracteres atingido.");
    } else {
      setEmitenteDescErrorr("");
    }

    setErrorApi(false);
    setEmitentePartDesc(value);
  };

  return (
    <>
      <div className="containerFilters">
        <div>
          <Input
            id="material-part-desc"
            label=""
            placeholder="Emitente: e-mail completo"
            img={SearchFilterIcon}
            value={emitentePartNumber}
            onChange={handleEmitenteChange}
            aria-describedby="Emitente"
            inputRef={emitenteInputRef}
            maxLength={50}
          />

          {emitenteDescError && (
            <ContainerError
              id="material-part-desc-error containerErro"
              label={emitenteDescError}
              icon={IconAlert}
              backgroudError={"#D1E4FF"}
              widthError=""
              colorError={"#000000"}
            />
          )}
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            position: "relative",
          }}
        >
          <CalendarInput
            key={calendarKey}
            value={dateRange}
            onChange={setDateRange}
            img={CalendarFilter}
            onDateChange={(from, to) => {
              setStartDate(from);
              setEndDate(to);
              setStartDateLocal(from);
              setEndDateLocal(to);
            }}
            isOpen={isCalendarOpen}
            setIsOpen={setIsCalendarOpen}
            onDateTypingChange={handleDateTyping}
          />

          {dateError && (
            <ContainerError
              id="calendar-date-error containerErro"
              label="Data de início não pode ser maior que a de fim."
              icon={IconAlert}
              backgroudError={"#FFD9D9"}
              widthError="257px"
              colorError={"#000000"}
              classAuxiliar={"positionError"}
            />
          )}

          {Array.isArray(sessionDashboard?.content) &&
            sessionDashboard?.content?.length === 0 && (
              <ContainerError
                id="calendar-date-error containerErro"
                label="O Período selecionado deve ser menor que 12 meses."
                icon={IconAlert}
                backgroudError={"#FFD9D9"}
                widthError="257px"
                colorError={"#000000"}
                classAuxiliar={"positionError"}
              />
            )}
        </div>

        <div style={{ display: "flex", marginTop: 3 }}>
          {handleFilter && (
            <ButtonGeneric
              img={Filter}
              title="Aplicar filtros"
              colorTitle="#FFFFFF"
              background=""
              style="buttonHeading"
              onClick={() => {
                handleFilter();
                validateDates(
                  localStorage.getItem("startDate"),
                  localStorage.getItem("endDate"),
                  setErrorApply
                );
              }}
              disabled={isFilterButtonDisabled}
            />
          )}

          <div style={{ marginLeft: 10 }}>
            <ButtonGeneric
              img={LixoIcon}
              title="Limpar filtros"
              colorTitle="#007BC0"
              background=""
              style="buttonLixo"
              onClick={() => {
                clearFilters();
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default FiltersDasboard;
